import { LanguagesService } from '@alpha-core/platform-ui';
import { ADMIN_INBOX_CONFIGS } from '@alpha-core/platform-ui/interfaces/admin-filter.interface';
import { Pipe, PipeTransform, inject } from '@angular/core';

@Pipe({
    name: 'inboxSearch',
    standalone: true,
})
export class InboxSearchPipe implements PipeTransform {
    private languageService = inject(LanguagesService);

    transform(value: Array<ADMIN_INBOX_CONFIGS>, searchKey: string): Array<ADMIN_INBOX_CONFIGS> {
        if (!value) return [];
        if (!searchKey) return value;
        const lowerCaseSearchKey = searchKey.toLowerCase();

        return value.filter((config) =>
            (this.languageService.getTranslation(config.name) || config.name)
                ?.toLowerCase()
                .includes(lowerCaseSearchKey),
        );
    }
}
